<p>child-curriculum-dashboard works!</p>
